// context/AuthContext.js
import { useContext, createContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth , db} from "../firebase";
import { getDoc, doc } from "firebase/firestore";
import i18n from "../locales/i18n";
export const AuthContext = createContext();

const fetchPreferredLanguage = async (user) => {
    if (!user) return; // 🔒 Prevents null errors

    const docSnap = await getDoc(doc(db, "users", user.uid));
    const lang = docSnap.data()?.language || "en";
    i18n.changeLanguage(lang);
  };

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsub = onAuthStateChanged(auth, (user) => {
            setCurrentUser(user);
            setLoading(false);
            
            if (user) {
                fetchPreferredLanguage(user);
              }
        });

        return () => unsub();
    }, []);

    return (
        <AuthContext.Provider value={{ currentUser }}>
            {!loading && children}
        </AuthContext.Provider>
    );
};


export const useAuth = () => useContext(AuthContext);